import { InjectionToken } from '@angular/core';

/** Base URL of the deployed help API (HelpApiStack output `HelpApiUrl`). Provided from `environment`. */
export const HELP_API_URL = new InjectionToken<string>('HELP_API_URL');
